import { useParams } from '@tanstack/react-router'

export const useClientPortalEoirPublicUrlParams = () => {
  const { encodedCaseId } = useParams({ from: '/client-portal/eoir/public/$encodedCaseId' })

  const decodedCaseId = decodeURIComponent(atob(encodedCaseId))

  return { caseId: decodedCaseId }
}
